<template>
  <div class="wrappers">
    <div class="homes">
      <van-search v-model="searchValue" placeholder="请输入搜索关键词" show-action @search="onSearch" class="mySearchs" enterkeyhint="search">
        <div slot="action" @click="onSearch"></div>
      </van-search>
      <div class="contentlistS">
        <div class="contentareaS">
          <template>
            <template v-if="this.infoList && this.infoList.length > 0">
              <div class="vv-cardS" v-for="info of this.infoList" :key="info.id" @click="()=>openVideo(info)">
                <div class="TSImageS">
                  <img :src="info.bg" />
                </div>
                <div class="TScontentS">
                  <div class="TStitleS">{{ info.title }}</div>
                  <div class="TSDescS" v-if="info.channel_type=='offcn'||info.channel_type=='zhuxue'||info.channel_type=='haixue'">
                    <span class="new-price">￥{{info.total_fee/100}}</span>
                  </div>
                  <div class="TSDescS" v-else>
                    <div v-if="info.category_path">{{info.category_path}}</div>
                    <div><span>{{`${info.file_total}节/${Number(info.duration/60).toFixed(0)}分钟`}}</span>    <!-- <span style="padding-left: 4px">{{`${info.learn_user_total || 1}人学过`}}</span>--></div>

                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="contentlineS">
                没有匹配的课程
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo,recordRouter } from '@/api/shopapi';
export default {
  name: 'SchoolSearch',
  data () {
    return {
      searchValue: '',
      infoList: [],
      loading: false
    }
  },
  watch: {
    '$route.params': {
      handler(n,o) {
        let ot = o.stitle
        let nt = n.stitle
        if(nt && ot !== nt)
          this.refresh(nt)
      },
      deep:true
    }
  },
  async mounted() {
    await this.refresh(this.$route.params.stitle.toString())
  },
  computed: {},
  methods: {
    async refresh (sv) {
      this.searchValue = sv
      const { data }  =  await getInfo({
        category_id: null,
        title: this.searchValue,
        page_no: 0,
        page_size: 100000
      })
      this.infoList = []
      this.$nextTick(()=>{
        this.infoList = data.data_list.map(m=>{
          m.bg = m.bg || '../../../static/img/bg/ept.jpg'
          return m
        })
      })
    },
    async onSearch () {
      if(this.loading) {
        return
      }
      try {
        this.loading = true
        const res = await getInfo({
          category_id:  null,
          page_no: 0,
          page_size: 100000,
          title: this.searchValue
        })
        this.$nextTick(()=>{
          this.infoList = res.data.data_list.map(m=>{
            m.bg = m.bg || '../../../static/img/bg/ept.jpg'
            return m
          })
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    openVideo (info) {
      console.log('info', info)
      if (info.linktype === 4) {
        let para={
          method: null,
          url: info.url
        }
        recordRouter(para).then(res => {
          console.log('记录信息:', res)
        }).catch(error => {
          console.log(error);
        });
        location.href = info.url
      } else {
        this.$router.push({ name: "PlayVideo", params: info })
      }
    }
  }
}
</script>
<style>
.homes{
  background: transparent;
  width: 100%;
  display: flex;
  height: calc(100vh - 46px);
  padding-bottom: 46px;
  flex-direction: column;
}
.mySearchs{
  position: absolute;
  top: 0;
  width: 90%;
  background: transparent!important;
  left: 5%;
  font-size: 12px;
  z-index:101
}
.mySearchs .van-cell{
  padding: 0px!important;
}
.mySearchs .van-search__content {
  border: 1px solid red;
  border-radius: 25px;
}
.wrappersS {
  position: relative;
  display: block;
  background-color: #f3f2f2;
  width: 100%;
  height: 100vh;
}
.contentlistS {
  display: flex;
  position: relative;
  height: 100%;
  padding-top: 46px;
  flex-direction: row;
}
.contentareaS {
  position: relative;
  flex: 1;
  height: calc(100vh - 92px);
  overflow-y: scroll;
  background-color: #fff;
}
.contentlineS {
  padding: 10px 0px 0px 40px;
  font-size: 0.37rem;
  line-height: 0.44rem;
  font-weight: 600;
}
.contentareaS > .contentwrapperS:nth-child(1) {
  padding-top: 10px;
}
.contentwrapperS {
  padding-bottom: 20px;
}
.contentlineS::before {
  display: block;
  position: absolute;
  color: red;
  text-align: center;
  font-weight: 500;
  font-size: 0.37rem;
  line-height: 0.37rem;
  height: 0.37rem;
  width: 40px;
  content: '●';
  left: 0px;
}
.contentchildS {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.contentchildS > div {
  margin: 5px 15px;
  padding: 3px 10px;
  border: 1px solid red;
  border-radius: 15px;
}
.vv-cardS {
  display: flex;
  height: 2rem;
  margin: 8px 8px;
  background-color:white;
}

.vv-cardS > div {
  flex: auto;
  height: auto;
}

.TStitleS {
  /*margin-top: 8px;*/
  /*margin-bottom: 8px;*/
  /*font-size: 0.3rem;*/
  /*line-height: 1.1;*/
  /*height: 1rem;*/
  /*overflow-y: hidden;*/
  /*word-break: break-all;*/
  /*flex: 1;*/

  padding-top: 10px;
  /*padding-bottom: 8px;*/
  font-size: 0.3rem;
  line-height: 1.1;
  height: 1rem;
  /*overflow-y: hidden;*/
  word-break: break-all;
  /*flex: 1;*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*overflow: hidden;*/
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  -webkit-box-orient: vertical;
}

.TScontentS {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}

.TSImageS {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  /* border: 1px solid rgb(119, 119, 119); */
}

.TSImageS > img {
  width: 100%;
  height: auto;
  display: block;
}

.TSDescS {
  display: flex;
  flex-direction: column;
  font-weight: lighter;
  font-size: 0.3rem;
}
</style>
